import moment from "moment";

const generatedFormatDate = (timestamp) => {
  if (!timestamp) return "";
  return moment.unix(timestamp).format("DD-MM-YYYY");
};

export default generatedFormatDate;